import { UserNotificationItem } from 'src/app/Data/service/http-help.service';
import { NotificationReadEvent } from 'src/app/models/task.model';

/** Close OS / SW notifications matching the given tags. */
export async function closePushByTags(tags: string[]): Promise<void> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }
  const unique = [...new Set(tags.filter(Boolean))];
  if (!unique.length) {
    return;
  }
  try {
    const reg = await navigator.serviceWorker.ready;
    for (const tag of unique) {
      const list = await reg.getNotifications({ tag });
      list.forEach((n) => n.close());
    }
  } catch (err) {
    console.warn('[PushNotification] closePushByTags failed:', err);
  }
}

/** Resolve push tags from WS payload + known inbox items. */
export function resolvePushTagsFromReadEvent(
  payload: NotificationReadEvent,
  inboxItems: UserNotificationItem[],
): string[] {
  const tags = new Set<string>();

  for (const id of payload.notification_ids || []) {
    const item = inboxItems.find((n) => n.id === id);
    if (item?.push_tag) {
      tags.add(item.push_tag);
    }
  }

  if (payload.task_id != null) {
    if (payload.message_ids?.length) {
      for (const messageId of payload.message_ids) {
        tags.add(`task-${payload.task_id}-msg-${messageId}`);
      }
    } else if (payload.read_source === 'task_view') {
      tags.add(`task-${payload.task_id}`);
    }
  }

  return [...tags];
}

/** Build push tag from FCM data payload when backend sends structured fields. */
export function pushTagFromFcmData(data: Record<string, string | undefined> | null | undefined): string | null {
  if (!data) {
    return null;
  }
  if (data.tag) {
    return data.tag;
  }
  if (data.push_tag) {
    return data.push_tag;
  }
  const taskId = data.task_id;
  const messageId = data.message_id;
  const notificationId = data.notification_id;
  if (taskId && messageId) {
    return `task-${taskId}-msg-${messageId}`;
  }
  if (taskId) {
    return `task-${taskId}`;
  }
  if (notificationId) {
    return `broadcast-${notificationId}`;
  }
  return null;
}
